@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package com.budgeyet.generated.resources

import kotlin.OptIn
import org.jetbrains.compose.resources.DrawableResource

private object CommonMainDrawable0 {
  public val budge_yet_logo: DrawableResource by 
      lazy { init_budge_yet_logo() }
}

internal val Res.drawable.budge_yet_logo: DrawableResource
  get() = CommonMainDrawable0.budge_yet_logo

private fun init_budge_yet_logo(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:budge_yet_logo",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "drawable/budge_yet_logo.png", -1, -1),
    )
)
